module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "m-t-lg"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.cropping),
      expression: "cropping"
    }],
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-6"
  }, [_c('div', {
    staticClass: "form-group float-label-control"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v(_vm._s(_vm.labelText))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "float-label",
      rawName: "v-float-label"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": _vm.labelText,
      "disabled": ""
    },
    domProps: {
      "value": _vm.fileName
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-6"
  }, [_c('label', {
    staticClass: "btn btn-primary btn-sm btn-block",
    class: {
      'disabled': _vm.$user.isDisabled
    },
    attrs: {
      "for": ("photo_input_" + _vm.name)
    }
  }, [_c('input', {
    staticClass: "sr-only",
    attrs: {
      "type": "file",
      "disabled": _vm.$user.isDisabled,
      "id": ("photo_input_" + _vm.name),
      "name": "file",
      "accept": ".jpg,.jpeg,.png,.gif"
    },
    on: {
      "change": _vm.handleFileSelection,
      "input": _vm.handleFileSelection
    }
  }), _vm._v("\n        Select Photo\n      ")])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.cropping && _vm.imageIsSelected),
      expression: "cropping && imageIsSelected"
    }],
    staticClass: "crop-container-outer m-t-sm m-b-sm"
  }, [_c('div', {
    staticClass: "crop-container"
  }, [(_vm.haveNoExistingImage) ? _c('img', {
    attrs: {
      "id": ("crop-image-" + _vm.name)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.haveExistingImage) ? _c('img', {
    attrs: {
      "id": ("crop-image-" + _vm.name),
      "src": _vm.originalDataUri
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "m-t-sm"
  }, [_c('ladda-button', {
    attrs: {
      "on-click": _vm.handleSaveCrop,
      "max-width": true,
      "size": "xsmall",
      "type": "info"
    }
  }, [_vm._v("Save Crop")])], 1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.notCropping),
      expression: "notCropping"
    }],
    staticClass: "crop-preview"
  }, [_c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$user.isEnabled),
      expression: "$user.isEnabled"
    }],
    staticClass: "btn btn-info btn-edit-profile",
    on: {
      "click": _vm.handleEditCrop
    }
  }, [_c('i', {
    staticClass: "fa fa-pencil disabled"
  })]), _vm._v(" "), _c('div', {
    staticClass: "preview"
  }, [(_vm.preview) ? _c('img', {
    class: _vm.className,
    attrs: {
      "src": _vm.preview
    }
  }) : (_vm.haveExistingImage) ? _c('img', {
    class: _vm.className,
    attrs: {
      "src": _vm.existingPreviewPath
    }
  }) : _vm._e()])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ../~/vue-loader/lib/template-compiler?{"id":"data-v-1e98e3c6"}!../~/vue-loader/lib/selector.js?type=template&index=0!./src/components/forms/PhotoCropper.vue
// module id = 945
// module chunks = 0